import axios from 'axios';

// When the server's 24h owner session ends, any private API call returns 401 "Login required" → show the PIN screen.
const expire = () => window.dispatchEvent(new Event('owner-session-expired'));

axios.interceptors.response.use((r) => r, (err) => {
  if (err.response?.status === 401 && err.response?.data?.detail === 'Login required') expire();
  return Promise.reject(err);
});

const nativeFetch = window.fetch.bind(window);
window.fetch = async (...args) => {
  const res = await nativeFetch(...args);
  if (res.status === 401) {
    res.clone().json().then((d) => { if (d?.detail === 'Login required') expire(); }).catch(() => {});
  }
  return res;
};
